import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BlockAudioModule } from '@app/components/blocks/block-audio/block-audio.module';
import { BlockBarChartModule } from '@app/components/blocks/block-barChart/block-barChart.module';
import { BlockButtonModule } from '@app/components/blocks/block-button/block-button.module';
import { BlockCarouselModule } from '@app/components/blocks/block-carousel/block-carousel.module';
import { BlockCheckboxModule } from '@app/components/blocks/block-checkbox/block-checkbox.module';
import { BlockContainerModule } from '@app/components/blocks/block-container/block-container.module';
import { BlockFeedbackModule } from '@app/components/blocks/block-feedback/block-feedback.module';
import { BlockGaugeChartModule } from '@app/components/blocks/block-gaugeChart/block-gaugeChart.module';
import { BlockHtmlModule } from '@app/components/blocks/block-html/block-html.module';
import { BlockIconTextModule } from '@app/components/blocks/block-iconText/block-iconText.module';
import { BlockLifeChangesModule } from '@app/components/blocks/block-lifeChanges/block-lifeChanges.module';
import { BlockLifeactModule } from '@app/components/blocks/block-lifeact/block-lifeact.module';
import { BlockLifemapModule } from '@app/components/blocks/block-lifemap/block-lifemap.module';
import { BlockModuleOverviewModule } from '@app/components/blocks/block-module-overview/block-module-overview.module';
import { BlockRadioboxModule } from '@app/components/blocks/block-radiobox/block-radiobox.module';
import { BlockSpiderChartModule } from '@app/components/blocks/block-spiderChart/block-spiderChart.module';
import { BlockTextareaModule } from '@app/components/blocks/block-textarea/block-textarea.module';
import { BlockTextboxModule } from '@app/components/blocks/block-textbox/block-textbox.module';
import { BlockUlModule } from '@app/components/blocks/block-ul/block-ul.module';
import { BlockViaSurveyModule } from '@app/components/blocks/block-viaSurvey/block-viaSurvey.module';
import { BlockVideoModule } from '@app/components/blocks/block-video/block-video.module';
import { BlockWordCloudModule } from '@app/components/blocks/block-wordCloud/block-wordCloud.module';
import { BottomNavigationModule } from '@app/components/bottomNavigation/bottomNavigation.module';
import { ButtonModule } from '@app/components/button/button.module';
import { ContainerModule } from '@app/components/container/container.module';
import { CourseContentComponent } from './courseContent.component';
import { CourseContentRoutingModule } from './courseContent-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HomeSectionModule } from '@app/home/homeSection/homeSection.module';
import { IconTextModule } from '@app/components/iconText/iconText.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { PlInputModule } from '@app/components/pl-input/pl-input.module';
import { ScrollToInvalidControlOnSubmitDirective } from '@app/courseContent/scroll-to-invalid-control-on-submit.directive';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  imports: [
    BlockAudioModule,
    BlockBarChartModule,
    BlockButtonModule,
    BlockCarouselModule,
    BlockCheckboxModule,
    BlockContainerModule,
    BlockFeedbackModule,
    BlockGaugeChartModule,
    BlockHtmlModule,
    BlockIconTextModule,
    BlockLifeChangesModule,
    BlockLifeactModule,
    BlockLifemapModule,
    BlockModuleOverviewModule,
    BlockRadioboxModule,
    BlockSpiderChartModule,
    BlockTextareaModule,
    BlockTextboxModule,
    BlockUlModule,
    BlockViaSurveyModule,
    BlockVideoModule,
    BlockWordCloudModule,
    BottomNavigationModule,
    ButtonModule,
    CommonModule,
    ContainerModule,
    CourseContentRoutingModule,
    FormsModule,
    HomeSectionModule,
    IconTextModule,
    MatSlideToggleModule,
    PlIconModule,
    PlInputModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  declarations: [CourseContentComponent, ScrollToInvalidControlOnSubmitDirective],
  exports: [CourseContentComponent],
})
export class CourseContentModule {}
